import styled from 'styled-components';

import Heading from '../../../components/Heading/Heading.styled';

export const PopupContentStyle = {
  padding: 0,
};

export const ControlsWrapperStyled = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;

  display: flex;
  gap: 20px;
  justify-content: flex-end;
  align-items: center;
  padding: 7px 60px 7px 30px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
`;

export const SocialIconsWrapper = styled.div`
  display: flex;
  gap: 10px;
`;

export const PrintIconsWrapperStyled = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
`;

export const CertificateWrapperStyled = styled.div`
  margin-top: 45px;

  max-height: 600px;
  min-height: 300px;
  height: 100%;
  overflow: auto;

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const MessageStyled = styled.div`
  text-align: center;
  margin-top: 40px;
`;

export const TitleStyled = styled(Heading)`
  flex: 1;

  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;
